<div class="planner-subjects-container">
  <div class="card card-day p-0" *ngFor="let lesson of visibleLessons()">

    <div class="d-flex justify-content-between align-items-start p-2 bg-level-primary">
      <p class="color-white fs-large fw-400 mb-0">{{lesson?.name}}</p>

      <app-gray-button
        *ngIf="config.canAddTopic"
        type="button" color="primary" [weight]="500"
        [text]="'planner.add_topic'|translate"
        padding="px-2 py-1" customClass="d-flex align-items-center fs-small border-8"
        [fullWidth]="false" (click)="addTopicRequested.emit(lesson)"></app-gray-button>
    </div>

    <div class="d-flex justify-content-center align-items-start w-100 h-100">
      <div class="day-card-body w-100 d-flex flex-column gap-2 p-2 overflow-y-auto">
        <app-planner-item
          *ngFor="let item of itemsByLesson[lesson.id]; let i = index"
          [item]="item" [index]="i" [config]="config" [videoTemplate]="videoTemplate" [menuTemplate]="menuTemplate"
          (toggled)="itemToggled.emit($event)"
          (transferRequested)="itemTransferRequested.emit($event)"
          (duplicateRequested)="itemDuplicateRequested.emit($event)"
          (removeRequested)="itemRemoveRequested.emit($event)"
          (menuOpened)="itemMenuOpened.emit($event)"></app-planner-item>
      </div>
    </div>

  </div>
</div>
